import { render, staticRenderFns } from "./InstitutionUsersList.vue?vue&type=template&id=040427f3"
import script from "./InstitutionUsersList.vue?vue&type=script&lang=js"
export * from "./InstitutionUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports